import { useTranslations } from 'next-intl';
import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { AsyncData, ResultEmpty, ResultFailure } from '@headless-workspace/core-domain';
import { useSafeSWR } from '../../../../../client';
import { getProductServerAction, ProductDetailValue } from '../../../../../server';
import { ProductDetailsErrors } from '../ProductDetailsErrors';

export const useProductDetails = (productId: string): AsyncData<ProductDetailValue> => {
    const t = useTranslations('Discover.Pdp.productInfo.error');

    const { data, isLoading, error } = useSafeSWR(
        [CacheKeys.Products, productId],
        ServerActionName.getProductById,
        () => getProductServerAction(productId),
    );

    if (error) {
        return {
            isLoading,
            result: ResultFailure(ProductDetailsErrors.Default, error instanceof Error ? error.message : t('default')),
        };
    }

    if (!data) {
        return { isLoading, result: ResultEmpty() };
    }

    return { isLoading, result: data };
};
